import { authHeader } from "./managerAuth";
export type NotifyResult = "delivered" | "simulated" | "failed";

/** An optional call-to-action for the email — a deep link and its button
    label, so "filed a report" can land the reader ON that report rather than
    the studio front door. Falls back to the site root when omitted. */
export interface NotifyCta { link?: string; label?: string }

/** Email notification through the Worker. Delivery is real when
    RESEND_API_KEY is bound; otherwise the Worker logs and acknowledges.
    Never throws — callers that want feedback await the returned status,
    everyone else keeps fire-and-forget semantics. */
export function notify(to: string[] | string, subject: string, body: string, cta?: NotifyCta): Promise<NotifyResult> {
  const recipients = (Array.isArray(to) ? to : [to]).filter(Boolean);
  if (!recipients.length) return Promise.resolve("failed");
  return fetch("/api/notify", {
    method: "POST",
    headers: { "Content-Type": "application/json", ...authHeader() },
    body: JSON.stringify({ to: recipients, subject, body, link: cta?.link, label: cta?.label }),
  })
    .then(async (res) => {
      const out = await res.json().catch(() => null) as { ok?: boolean; delivered?: boolean; simulated?: boolean } | null;
      if (!res.ok || !out?.ok) return "failed";
      return out.delivered ? "delivered" : "simulated";
    })
    .catch(() => "failed" as const);
}
